import * as React from "react"
import gsap from 'gsap'

var currentImage = 1;
var imageTransition = false; 

function setCoverImage(image) {
  document.querySelector('.hover--image.active').classList.remove('active');
  document.querySelector('.hover--image[data-image="'+image+'"]').classList.add('active');
} 

class PageLinks extends React.Component {
  mouseOverLink(e) { 
    var target = e.target.closest('.hover--link'); 
    if(target) {
      var cursor = target.getAttribute('data-cursor'); 
      console.log(cursor);  
      document.querySelector('.floating--cursor .caption .inner').innerHTML = cursor;
      var image = target.getAttribute('data-image');
      if(image !== currentImage && imageTransition === false) {
        currentImage = image; 
        imageTransition = true;
        setTimeout(function(){ imageTransition=false; }, 300);    
        setCoverImage(image);
      }
    }
      
  }

  mouseOverContainer(e) {
    document.querySelector('.image-card--hover').classList.add('is-showing');
    var cursor = document.querySelector('.image-card--hover');
    gsap.to(cursor, 1, {
      css: {
        left:e.clientX,
        top: e.clientY
      }
    });
  } 

  mouseLeaveContainer() {
    document.querySelector('.image-card--hover').classList.remove('is-showing');
  }

  render() {
    
    const Link = ({link, title, image, align, margin, delay, aDelay, cursor, comingSoon}) => {
      if(!comingSoon) { var linkClass = 'internal--link';}
      return (
        <div data-scroll data-scroll-offset="300" role="presentation"  onMouseOver={this.mouseOverLink}  onFocus={this.mouseOverLink}>
          <div className={"text-wrapper h1 first "+align}>
            <a className={'arrow-expand hover--link '+linkClass} href={link} data-cursor={cursor} data-image={image}>
              <div data-scroll data-scroll-offset="200">
                <span className="text-wrapper"><span className="word pl10 pr10" style={{'transitionDelay':delay}}>{title}</span> <div className={"arrow-icon "+aDelay} >→</div></span> 
              </div> 
            </a>
          </div>
        </div>
      )
    } 

    return (

      <div className="internal-page--links p30 title--animation" data-scroll data-scroll-offset="300" role="presentation" onMouseOver={this.mouseOverContainer}  onFocus={this.mouseOverContainer} onMouseOut={this.mouseLeaveContainer}  onBlur={this.mouseLeaveContainer}> 
        
        <Link link="/approach" image={"1"} title="Approach" cursor="Explore" delay="0.1s" aDelay="d-1" /> 

        <Link link="/portfolio" image={"2"} title="Folio" cursor="Explore" delay="0.2s" />

        <Link link="/films" image={"3"} title="Films" cursor="Explore" align="text-right" delay="0.3s" margin="mr40"/> 

        <Link link="/about" image={"4"} title="About" cursor="Explore"  delay="0.4s" />

        <Link  image={"5"} comingSoon='coming-soon' title="Store" cursor="Coming Soon" align="text-center" delay="0.5s" /> 

        <Link link="/contact" image={"6"} title="Contact" cursor="Explore" align="text-center" delay="0.6s" />

      </div>
    )
  } 
} 

export default PageLinks

